import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HiViewGrid, HiSpeakerphone, HiChartBar, HiOfficeBuilding, HiCollection, HiUserGroup, HiLogout, HiCube, HiDeviceMobile } from './Icons';
import { useAuth } from '../contexts/AuthContext';
import './AdminLayout.css';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, displayName } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>{displayName ? `Hi ${displayName}` : 'TappyTray Admin'}</h2>
        </div>
        <nav className="admin-nav">
          <Link
            to="/admin/dashboard"
            className={`nav-link ${isActive('/admin/dashboard') ? 'active' : ''}`}
          >
            <HiViewGrid size={20} /> Dashboard
          </Link>
          <Link
            to="/admin/promotions"
            className={`nav-link ${isActive('/admin/promotions') ? 'active' : ''}`}
          >
            <HiSpeakerphone size={20} /> Promotions
          </Link>
          <Link
            to="/admin/category-modules"
            className={`nav-link ${isActive('/admin/category-modules') ? 'active' : ''}`}
          >
            <HiCube size={20} /> Category modules
          </Link>
          <Link
            to="/admin/participating-events"
            className={`nav-link ${isActive('/admin/participating-events') ? 'active' : ''}`}
          >
            <HiSpeakerphone size={20} /> Participating Events
          </Link>
          <Link
            to="/admin/statistics"
            className={`nav-link ${isActive('/admin/statistics') ? 'active' : ''}`}
          >
            <HiChartBar size={20} /> Statistics
          </Link>
          <Link
            to="/admin/society-overview"
            className={`nav-link ${isActive('/admin/society-overview') ? 'active' : ''}`}
          >
            <HiOfficeBuilding size={20} /> Society Overview
          </Link>
          <Link
            to="/admin/societies"
            className={`nav-link ${isActive('/admin/societies') && !isActive('/admin/onboard-society') ? 'active' : ''}`}
          >
            <HiCollection size={20} /> Societies
          </Link>
          <Link
            to="/admin/onboard-society"
            className={`nav-link ${isActive('/admin/onboard-society') ? 'active' : ''}`}
          >
            <HiOfficeBuilding size={20} /> Onboard Society
          </Link>
          <Link
            to="/admin/parser-builder"
            className={`nav-link ${isActive('/admin/parser-builder') ? 'active' : ''}`}
          >
            <HiCube size={20} /> Statement Parsers
          </Link>
          <Link
            to="/admin/customers"
            className={`nav-link ${isActive('/admin/customers') ? 'active' : ''}`}
          >
            <HiUserGroup size={20} /> Customers
          </Link>
          <Link
            to="/admin/force-update"
            className={`nav-link ${isActive('/admin/force-update') ? 'active' : ''}`}
          >
            <HiDeviceMobile size={20} /> Force Update
          </Link>
        </nav>
        <div className="admin-sidebar-footer">
          <button onClick={handleLogout} className="logout-button">
            <HiLogout size={20} /> Logout
          </button>
        </div>
      </aside>
      <main className="admin-main">
        <header className="admin-header">
          <h1>TappyTray Promotion Management</h1>
        </header>
        <div className="admin-content">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;

